import { render } from "./AtendimentoRapido.vue?vue&type=template&id=ec5434d0&scoped=true&lang=pug"
import script from "./AtendimentoRapido.vue?vue&type=script&setup=true&lang=js"
export * from "./AtendimentoRapido.vue?vue&type=script&setup=true&lang=js"

import "./AtendimentoRapido.vue?vue&type=style&index=0&id=ec5434d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5434d0"]])

export default __exports__